import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export type CompanyProfileTab = "info" | "profile";

interface CompanyProfileTabsProps {
  onTabChange: (tab: CompanyProfileTab) => void;
}

const CompanyProfileTabs = ({ onTabChange }: CompanyProfileTabsProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get("tab");
  const activeTab: CompanyProfileTab =
    rawTab === "profile" ? "profile" : "info";

  useEffect(() => {
    if (rawTab && rawTab !== "info" && rawTab !== "profile") {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set("tab", "info");
      setSearchParams(nextParams, { replace: true });
      return;
    }

    onTabChange(activeTab);
  }, [activeTab, onTabChange, rawTab, searchParams, setSearchParams]);

  const selectTab = (tab: CompanyProfileTab) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("tab", tab);
    setSearchParams(nextParams);
  };

  return (
    <nav
      aria-label="プロフィール設定"
      className="flex h-[46px] w-full border-b border-[#d5d5d5]"
    >
      {[
        { key: "info" as const, label: "登録情報" },
        { key: "profile" as const, label: "公開プロフィール" },
      ].map(({ key, label }) => {
        const isActive = activeTab === key;

        return (
          <button
            key={key}
            type="button"
            aria-selected={isActive}
            role="tab"
            onClick={() => selectTab(key)}
            className={`relative h-[46px] px-[25px] pb-[12px] pt-[8px] text-[16px] font-bold leading-[1.6] ${
              isActive ? "text-[#1b4b86]" : "text-[#adbbcc]"
            }`}
          >
            {label}
            {isActive && (
              <span className="absolute bottom-0 left-0 h-[4px] w-full rounded-[2px] bg-[#1b4b86]" />
            )}
          </button>
        );
      })}
    </nav>
  );
};

export default CompanyProfileTabs;
